import React, { useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import moment from "moment";
import { useInvoiceProvider } from "../../../../Providers/Vendor/invoice";
import { InvoiceStatusLabel, roles } from "../../../../Utils/constants";
import ViewInvoice from "./ViewInvoice";
import StatusLabel from "../../../../Components/StatusLabel";
import CustomTable from "../../../../Components/Table";
import { useLocation, useNavigate } from "react-router-dom";

const headCells = [
  {
    id: "job-name",
    numeric: false,
    disablePadding: false,
    label: "Job Name",
  },
  {
    id: "Date",
    numeric: false,
    disablePadding: true,
    label: "Date",
  },
  {
    id: "Client",
    numeric: false,
    disablePadding: false,
    label: "Client",
  },
  {
    id: "Consultant",
    numeric: false,
    disablePadding: false,
    label: "Consultant",
  },
  {
    id: "Hours",
    numeric: false,
    disablePadding: false,
    label: "Hours",
  },
  {
    id: "Amount",
    numeric: false,
    disablePadding: false,
    label: "Amount",
  },
  {
    id: "Status",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
];

export default function Outgoing() {
  const [invoice, setInvoice] = useState();
  const { invoices, fetchInvoiceForUser } = useInvoiceProvider();
  const navigate = useNavigate()
  const location = useLocation()
  useEffect(() => {
    fetchInvoiceForUser(roles.vendor);
  }, []);

  const CustomRow = ({ row }) => {
    return (
      <TableRow
        hover
        role="checkbox"
        tabIndex={-1}
        key={row?.id}
        className="cursor-pointer"
        onClick={() =>
          navigate(`/dashboard/invoices/${row?.id}/${row?.job_id}`, { state: { from: location } })
        }
      >
        <TableCell align="left">{row?.job?.name}</TableCell>
        <TableCell
          component="th"
          scope="row"
          padding="none"
        >
          {moment.utc(row?.createdAt).format("DD/MM/YY")}
        </TableCell>
        <TableCell align="left">
          {row?.client?.role === "VENDOR" ? row?.client?.company : `${row?.client?.firstName} ${row?.client?.lastName}`}
        </TableCell>
        <TableCell align="left">
          {`${row?.consultant?.firstName} ${row?.consultant?.lastName}`}
        </TableCell>
        <TableCell align="left">{row?.hours}</TableCell>
        <TableCell align="left">{row?.amount}</TableCell>
        <TableCell align="left">
          <StatusLabel
            data={InvoiceStatusLabel[row?.status]}
          />
        </TableCell>
      </TableRow >
    );
  }

  return (
    <div>
      {!invoice ? (
        <>
          <CustomTable
            title="Invoices"
            headCells={headCells}
            rows={invoices}
            CustomRow={CustomRow}
          />
        </>
      ) : (
        <ViewInvoice
          invoice={invoice}
          setInvoice={setInvoice}
          showJobInfo={true}
        />
      )}
    </div>
  );
}
